import instance from './instance'
import 'firebase/auth'
export default instance.auth()
